import * as stateNames from 'constants/states'
import PermissionWrapper from 'components/Perms/PermissionWrapper'
import React from 'react'
import { useCreateModal, useDelete, useFetchList } from 'hooks'
import { getSerializedData } from 'utils/get'
import useUpdateModal from 'hooks/useUpdateModal'
import checkRole from '../../../utils/checkRole'
import SettingMessagesGrid from './components/SettingMessagesGrid'
import {
  smsTemplatesCreateAction, smsTemplatesDeleteAction,
  smsTemplatesListAction,
  smsTemplatesUpdateAction
} from './settingMessagesActions/settingMessagesActions'
import { fields } from './components/SettingMessagesCreateDrawer'

const SettingMessagesContainer = props => {
  const isDirector = checkRole(['director', 'superadmin'])

  const listData = useFetchList({
    action: smsTemplatesListAction,
    stateName: stateNames.SMS_TEMPLATES_LIST
  })
  const createDrawer = useCreateModal({
    serializer: (values) => getSerializedData(fields, values),
    action: smsTemplatesCreateAction,
    successAction: smsTemplatesListAction,
    stateName: stateNames.SMS_TEMPLATES_CREATE,
  })
  const deleteData = useDelete({
    stateName: stateNames.SMS_TEMPLATES_DELETE,
    action: smsTemplatesDeleteAction,
    successAction: smsTemplatesListAction
  })

  const updateData = useUpdateModal({
    listData,
    action: smsTemplatesUpdateAction,
    stateName: stateNames.SMS_TEMPLATES_CREATE,
    serializer: (values) => getSerializedData(fields, values),
    successAction: smsTemplatesListAction,
    initialValues: (data) => {
      return {
        ...data
      }
    }
  })

  return isDirector ? (
    <PermissionWrapper permissions={['READ']}>
      <SettingMessagesGrid
        listData={listData}
        createDrawer={createDrawer}
        deleteData={deleteData}
        updateData={updateData}
      />
    </PermissionWrapper>
  ) : <div/>
}

export default SettingMessagesContainer
